
import { onMounted } from 'vue'
import Food from './Food'

export default {
  name: 'PlayGround',
  setup (): void {
    let food: Food

    onMounted(() => {
      food = new Food()
      console.log('food', food);
    })
  }
}
